import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: '404', pathMatch: 'full' },
  {
    path: '404',
    loadComponent: () => import('./page-not-found/page-not-found.component').then((c) => c.PageNotFoundComponent),
  },
  {
    path: 'embed',
    loadComponent: () => import('./vehicle/vehicle.component').then((c) => c.VehicleComponent),
  },
  {
    path: 'trader/embed',
    loadComponent: () => import('./trader-vehicle/trader-vehicle.component').then((c) => c.TraderVehicleComponent),
  },
  {
    path: 'carbravo/embed',
    loadComponent: () => import('./vehicle/vehicle.component').then((c) => c.VehicleComponent),
  },
  {
    path: 'widget',
    loadComponent: () => import('./widgetconfig/widgetconfig.component').then((c) => c.WidgetConfigComponent),
  },
  {
    path: 'reporting',
    loadChildren: () => import('./reporting/reporting.routes').then((r) => r.reportingRoutes),
  },
  {
    path: 'login',
    loadComponent: () => import('./login-dialog/login-dialog.component').then((c) => c.LoginDialogComponent),
  },
  {
    path: 'viewemail/:country/:guid',
    loadComponent: () => import('./email-view/email-view.component').then((c) => c.EmailViewComponent),
  },
  {
    path: 'reviseoffer/:guid',
    loadComponent: () => import('./revise-lead/revise-lead.component').then((c) => c.ReviseLeadComponent),
  },
  {
    path: 'dealer-portal',
    loadComponent: () =>
      import('./dealer-portal-redirect/dealer-portal-redirect.component').then((c) => c.DealerPortalRedirectComponent),
  },
  {
    path: 'dealer-portal/**',
    loadComponent: () =>
      import('./dealer-portal-redirect/dealer-portal-redirect.component').then((c) => c.DealerPortalRedirectComponent),
  },
  { path: '**', redirectTo: '404', pathMatch: 'full' },
];
